<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm03">
<div class="chapterHead">
<h2 class="chapterTitle1" style="text-indent: 0%;"><span class="bold">Chronology</span></h2>
</div>
<div class="chapterBody">
<table>
<colgroup>
<col width="30%"/>
<col width="30%"/>
</colgroup>
<tbody>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">30 May 1536</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Henry marries Jane Seymour</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">12 October 1537</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward VI born</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">24 October 1537</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Jane Seymour dies</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">30 December 1546</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Henry makes his final will and testament</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">13 January 1547</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Earl of Surrey tried and convicted for treason</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">28 January 1547</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Henry VIII dies</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">31 January 1547</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward Seymour elected Protector</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">20 February 1547</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward’s coronation</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">5 March 1547</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Thomas Wriothesley resigns his post as Chancellor</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">10 September 1547</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Battle of Pinkie</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">19 March 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Sir Thomas Seymour executed</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">9 June 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">New Book of Common Prayer comes into use</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">10 June 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Western ‘Prayer Book’ rebellion begins at Sampford Courtenay, Devon</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">2 July 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Exeter besieged</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">8 July 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Kett’s rebellion, Norfolk, begins</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">6 August 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Siege at Exeter lifted</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">27 August 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Kett’s forces defeated by Dudley’s troops</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">5 October 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Somerset issues proclamation announcing conspiracy against him</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">7 October 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Somerset flees to Windsor with Edward</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">8 October 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Dudley and the council issue proclamation denouncing Somerset</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">11 October 1549</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Somerset arrested</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">January 1550</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Wriothesley and Arundel arrested</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">2 February 1550</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Dudley appointed Lord Great Master and Lord President of the Council</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">6 February 1550</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Somerset released from the Tower</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">2 May 1550</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Joan Bocher burned at the stake for heresy</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">7 May 1550</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Somerset readmitted to the council</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">2 July 1550</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Mary’s planned escape foiled</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">30 July 1550</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Wriothesley dies</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">17 March 1551</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward confronts Mary over her continued hearing of the mass</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">16? April 1551</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Attempt to assassinate Dudley foiled</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">8 May 1551</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Proclamation issued announcing debasement of the coinage</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">7 July 1551</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Outbreak of sweating sickness ravages London</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">23 August 1551</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Mary’s household officers arrested for disobedience</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">11 October 1551</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Dudley created Duke of Northumberland</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">16 October 1551</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Somerset arrested</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">1 December 1551</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Somerset tried and convicted of felony</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">22 January 1552</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Somerset executed</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">15 July 1552</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward leaves London for his first summer progress</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">1 November 1552</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Second Book of Common Prayer introduced</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">1 March 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward opens Parliament</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">11 April 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward moves to Greenwich on account of deteriorating illness</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">21 May 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Lady Jane Grey married to Dudley’s son, Guildford</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">21 June 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward’s ‘Devise’ approved</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">4 July 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Mary secretly travels towards Norfolk</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">6 July 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward dies</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">10 July 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Jane proclaimed Queen</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">19 July 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Mary proclaimed Queen</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">21 July 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Dudley arrested</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">8 August 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Edward buried</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">18 August 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Dudley tried and convicted of treason</p></td></tr>
<tr><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;"><span class="bold">22 August 1553</span></p></td><td valign="top">
<p class="paraNoIndent" style="text-indent: 0%;">Dudley executed</p></td></tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466805798_fm03.vue?fe473c0c